var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('iframe',{attrs:{"src":"https://crm.iotech.my.id/#/dashboard/external/approval-finance?hrId=84","width":"100%","height":"800","frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }